module.exports = __webpack_public_path__ + "static/media/black_quartz_corian.cbfe0a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/galleyColors/black_quartz_corian.jpg
// module id = 37
// module chunks = 0